// Shared helpers for the admin UI

export const INQUIRY_STATUSES = ["new", "answered", "converted", "lost"];

export const ESTABLISHMENT_TYPES = [
  "Académie sportive",
  "École",
  "Garderie / Crèche",
  "Salle de fitness",
  "Gymnase",
  "Centre sportif",
  "Autre",
];

export const FREQUENCIES = [
  { key: 1, label: "1 fois / mois" },
  { key: 2, label: "2 fois / mois" },
  { key: 4, label: "4 fois / mois" },
  { key: 8, label: "8 fois / mois" },
];

export const CONTRACT_TYPES = [
  { key: "recurring", label: "Passages réguliers" },
  { key: "one_time", label: "Intervention ponctuelle" },
];

export const STATUS_LABEL = {
  // inquiry
  new: "Nouvelle",
  answered: "Répondue",
  converted: "Convertie",
  lost: "Perdue",
  // payment
  sent: "Envoyé",
  pending: "En attente",
  paid: "Payé",
  active: "Actif",
  failed: "Échec",
  past_due: "En retard",
  cancelled: "Annulé",
  expired: "Expiré",
  manual_paid: "Payé manuel",
};

export const STATUS_CLASS = {
  new: "bg-blue-100 text-blue-800",
  answered: "bg-amber-100 text-amber-800",
  converted: "bg-emerald-100 text-emerald-800",
  lost: "bg-slate-200 text-slate-700",
  sent: "bg-amber-100 text-amber-800",
  pending: "bg-amber-100 text-amber-800",
  paid: "bg-emerald-100 text-emerald-800",
  active: "bg-emerald-100 text-emerald-800",
  failed: "bg-red-100 text-red-800",
  past_due: "bg-red-100 text-red-800",
  cancelled: "bg-slate-200 text-slate-700",
  expired: "bg-slate-200 text-slate-700",
  manual_paid: "bg-emerald-100 text-emerald-800",
};

export function normalizeServiceType(type) {
  if (["one_time", "one-time", "oneoff"].includes(type)) return "one_time";
  return "recurring";
}

export function serviceTypeLabel(type) {
  return normalizeServiceType(type) === "one_time" ? "Intervention ponctuelle" : "Passages réguliers";
}

// Local mirror of backend calculator for live preview
export function calcPriceLocal(surface, type, settings, applyFirstPromo = false) {
  const detail = {
    surface: Number(surface) || 0,
    type: normalizeServiceType(type),
    base: 0,
    promoApplied: false,
    promoAmount: 0,
    total: 0,
    currency: "CHF",
  };
  if (!surface || surface <= 0 || !settings) return detail;
  const pricing = settings.pricing || {};
  let rates;
  const serviceType = normalizeServiceType(type);
  if (serviceType === "recurring") rates = pricing.recurring || pricing.standard || {};
  else if (serviceType === "one_time") rates = pricing.oneoff || {};
  else return detail;
  const rate = Number(surface < 100 ? rates.under100 : rates.over100) || 0;
  detail.base = +(rate * Number(surface)).toFixed(2);
  let subtotal = detail.base;
  if (applyFirstPromo && (pricing.firstPromo || {}).enabled) {
    const ptype = pricing.firstPromo.type || "percent";
    const pval = Number(pricing.firstPromo.value) || 0;
    detail.promoAmount = ptype === "percent" ? +(subtotal * (pval / 100)).toFixed(2) : pval;
    detail.promoApplied = true;
  }
  detail.total = +Math.max(0, subtotal - detail.promoAmount).toFixed(2);
  return detail;
}

function digits(s = "") {
  return String(s).replace(/[^\d+]/g, "");
}

export function customerWhatsAppHref(customer, text) {
  const phone = digits(customer?.phone || "");
  const base = phone ? `https://wa.me/${phone.replace(/^\+/, "")}` : "https://wa.me/";
  return `${base}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
}

export function formatCHF(n) {
  if (n == null || isNaN(n)) return "—";
  return `CHF ${Number(n).toLocaleString("de-CH", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("fr-CH", { dateStyle: "short", timeStyle: "short" });
  } catch {
    return iso;
  }
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("fr-CH");
  } catch {
    return iso;
  }
}
